// extracted by mini-css-extract-plugin
export var line = "styles-module__line___cLBqR";
export var text = "styles-module__text___oBAa3";
export var wrapper = "styles-module__wrapper___W6lwG";